/* deploy: 2026-06-18 — Web Vitals via <script> IIFE (à prova do minificador do tema) */
/*
* Broadcast Theme — Custom JS
*/

(function () {

  // Ancora o widget de cálculo de frete (#ta-pq) sempre no bloco correto,
  // independente da posição que o app tentar injetar.
  var FRETE_BLOCK_ID = 'product-block--accordion_xBM4F9';
  var WIDGET_ID      = 'ta-pq';

  function getFreteTarget() {
    var block = document.getElementById(FRETE_BLOCK_ID);
    return block ? block.querySelector('[data-collapsible-body]') : null;
  }

  function anchorarWidget() {
    var widget = document.getElementById(WIDGET_ID);
    var target = getFreteTarget();
    if (widget && target && !target.contains(widget)) {
      target.appendChild(widget);
    }
  }

  function initFreteAnchor() {
    // Roda só em páginas de produto — evita overhead desnecessário em outras páginas
    if (!document.getElementById(FRETE_BLOCK_ID)) return;

    // Se o widget já existe, reposiciona imediatamente
    if (document.getElementById(WIDGET_ID)) {
      anchorarWidget();
      return;
    }

    // Caso contrário, observa até o app injetar e então reposiciona
    var observer = new MutationObserver(function () {
      if (document.getElementById(WIDGET_ID)) {
        observer.disconnect();
        anchorarWidget();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Garante que o observer não fica rodando para sempre
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreteAnchor);
  } else {
    initFreteAnchor();
  }

})();

// [Future Skateboards / Claude — 2026-09-18] Ordena os resultados da calculadora de
// frete (#ta-result) por preço crescente (grátis/mais barato primeiro), igual ao
// checkout — o widget do app exibe na ordem bruta que a API devolve (sem ordenar).
// Reobserva a cada clique em "Calcular Frete", já que o cliente pode recalcular.
(function () {

  var FRETE_BLOCK_ID = 'product-block--accordion_xBM4F9';
  var RESULT_ID       = 'ta-result';
  var isSorting        = false;

  function parsePreco(texto) {
    if (!texto) return Infinity;
    var match = texto.match(/([\d.,]+)/);
    if (!match) return Infinity;
    var valor = parseFloat(match[1].replace(/\./g, '').replace(',', '.'));
    return isNaN(valor) ? Infinity : valor;
  }

  function ordenarResultadosFrete(result) {
    var linhas = Array.prototype.slice.call(result.querySelectorAll('#ta-r-line'));
    if (linhas.length < 2) return;

    var ordenadas = linhas.slice().sort(function (a, b) {
      var precoA = parsePreco(a.children[1] && a.children[1].textContent);
      var precoB = parsePreco(b.children[1] && b.children[1].textContent);
      return precoA - precoB;
    });

    var jaOrdenado = ordenadas.every(function (linha, i) { return linha === linhas[i]; });
    if (jaOrdenado) return;

    isSorting = true;
    ordenadas.forEach(function (linha) { result.appendChild(linha); });
    isSorting = false;
  }

  function initOrdenacaoFrete() {
    // Roda só em páginas de produto — evita overhead desnecessário em outras páginas
    if (!document.getElementById(FRETE_BLOCK_ID)) return;

    var observer = new MutationObserver(function () {
      if (isSorting) return;
      var result = document.getElementById(RESULT_ID);
      if (result && result.children.length > 1) {
        ordenarResultadosFrete(result);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrdenacaoFrete);
  } else {
    initOrdenacaoFrete();
  }

})();

// [Future Skateboards / Claude — 2026-06-18] Web Vitals → GA4
// Envia LCP, CLS, FCP, INP, TTFB como eventos GA4 (non_interaction: true)
// IMPORTANTE: carrega via <script> IIFE + global window.webVitals — NÃO usar import()
// dinâmico aqui: o minificador do tema (esbuild target node) converte import()→require(),
// que não existe no navegador e mata a coleta em silêncio. Tag <script> sobrevive ao build.
(function () {
  function sendToGA4(metric) {
    if (typeof gtag !== 'function') return;
    gtag('event', metric.name, {
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      non_interaction: true
    });
  }
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/web-vitals@4/dist/web-vitals.attribution.iife.js';
  s.async = true;
  s.onload = function () {
    if (!window.webVitals) return;
    webVitals.onCLS(sendToGA4);
    webVitals.onFCP(sendToGA4);
    webVitals.onLCP(sendToGA4);
    webVitals.onTTFB(sendToGA4);
    webVitals.onINP(sendToGA4);
  };
  document.head.appendChild(s);
})();
